import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../../../service/api";
import { paymentMethodOptions } from "../../Sales/Invoice/Payments/PaymentMethodOptions";
import { addDefaultOption } from "../../../../utils/utility";
import { FileUpload } from "../../../../components/FileUpload";

export default function OverPaidModal({
    show,
    onHide,
    row,
    onUpdated,
    isOverPaidModal = true,
}) {
    const [loading, setLoading] = useState(false);

    const [actionType, setActionType] = useState(""); // WRITE_OFF | REFUND

   

    const [form, setForm] = useState({
        id:"",
        amount: "",
        refund_date: "",
        payment_method: "",
        reference_number: "",
    });
    const [refundFiles, setRefundFiles] = useState([]);


    useEffect(() => {
        if (row) {
            setForm((prev) => ({
                ...prev,
                amount: row?.remaining_amount || "0.00",
            }));
        }
    }, [row]);

    const handleChange = (key, value) => {
        setForm((prev) => ({
            ...prev,
            [key]: value,
        }));

        if(!isOverPaidModal){
            setActionType("REFUND")
        }
    };

    const resetState = () => {
        setActionType("");
        setForm({
            id:"",
            amount: "",
            refund_date: "",
            payment_method: "",
            reference_number: "",
        });
        setRefundFiles([]);
    };

    const handleClose = () => {
        resetState();
        onHide();
    };

    const handleSubmit = async () => {
        if (!row || !actionType) return;

        try {
            setLoading(true);

            

            const payload = new FormData();
            if (row?.id) {
                payload.append("id", row.id);
            }

            payload.append("type", actionType);
            payload.append("amount", form.amount);
            payload.append("status", isOverPaidModal ? "PENDING" : "APPROVED");

            const reason = actionType === "REFUND" ? "refund" : "write_off";
            payload.append("reason", reason);

            if (actionType === "REFUND") {
                payload.append("refund_date", form.refund_date);
                payload.append("payment_method", form.payment_method);
                payload.append("reference_number", form.reference_number);

                refundFiles?.forEach((item) => {
                    payload.append("attachments[]", item.file);
                });
            }


            await api.post(
                `tms/bank-transaction/overpaid-action/${row.id}`,
                payload
            );

            onUpdated();
            handleClose();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isOverPaidModal
                        ? "Overpaid Action"
                        : "Update Refund Details"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isOverPaidModal && (
                    <>
                        {/* RADIO OPTIONS */}
                        <Form.Group className="mb-3">
                            <Form.Label>Action Type</Form.Label>

                            <div className="d-flex gap-3">
                                <Form.Check
                                    type="radio"
                                    id="write-off-radio"
                                    label="Overpaid Write Off"
                                    name="actionType"
                                    value="WRITE_OFF"
                                    checked={actionType === "WRITE_OFF"}
                                    onChange={(e) =>
                                        setActionType(e.target.value)
                                    }
                                />

                                <Form.Check
                                    type="radio"
                                    id="refund-radio"
                                    label="Refund"
                                    name="actionType"
                                    value="REFUND"
                                    checked={actionType === "REFUND"}
                                    onChange={(e) =>
                                        setActionType(e.target.value)
                                    }
                                />
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Amount</Form.Label>
                            <Form.Control
                                readOnly
                                type="number"
                                value={form.amount ?? "0.00"}
                                onChange={(e) =>
                                    handleChange("amount", e.target.value)
                                }
                            />
                        </Form.Group>
                    </>
                )}

                {/* REFUND FIELDS */}
                {!isOverPaidModal && (
                    <>
                        <Form.Group className="mb-2">
                            <Form.Label>Refund Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={form.refund_date || row?.bank_details?.refund_date}
                                onChange={(e) =>
                                    handleChange("refund_date", e.target.value)
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Payment Method</Form.Label>

                            <Form.Select
                                value={form.payment_method || row?.bank_details?.payment_method}
                                onChange={(e) =>
                                    handleChange(
                                        "payment_method",
                                        e.target.value
                                    )
                                }
                            >
                                {addDefaultOption(
                                    paymentMethodOptions.filter(
                                        (option) => option.value !== "OFFSET"
                                    )
                                ).map((option) => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Reference Number</Form.Label>
                            <Form.Control
                                type="text"
                                value={form.reference_number || row?.bank_details?.reference_number}
                                onChange={(e) =>
                                    handleChange(
                                        "reference_number",
                                        e.target.value
                                    )
                                }
                            />
                        </Form.Group>
                    </>
                )}
                {actionType === "REFUND" && (
                    <>
                        {isOverPaidModal && (
                            <>
                                <Form.Group className="mb-2">
                                    <Form.Label>Supporting Document</Form.Label>
                                    <FileUpload
                                        files={refundFiles}
                                        setFiles={setRefundFiles}
                                        name="attachments"
                                        allowMultiple={false}
                                        maxFiles={1}
                                        className="fileupload-bg"
                                    />
                                </Form.Group>
                            </>
                        )}
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading || !actionType}
                >
                    {loading ? "Processing..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
